module.exports = isWarehouseMatch

// Must take a user's location and a shipment's location as plain inputs,
// never branch on role identity — this is shared infrastructure between
// client permission checks and server authorization checks, not an
// Operator-specific function.
function isWarehouseMatch (userLocationId, shipmentDestinationId) {
  return !!userLocationId && userLocationId === shipmentDestinationId
}
